import ImageAif from '@/assets/images/partners/partner-aif.png';
import ImageAnimoca from '@/assets/images/partners/partner-animoca.png';
import ImageAvalanche from '@/assets/images/partners/partner-avalanche.png';
import ImageAws from '@/assets/images/partners/partner-aws.png';
import ImageBitTrade from '@/assets/images/partners/partner-bittrade.png';
import ImageChainlink from '@/assets/images/partners/partner-chainlink.png';
import ImageCoinplug from '@/assets/images/partners/partner-coinplug.png';
import ImageCoinpost from '@/assets/images/partners/partner-coinpost.png';
import ImageConflux from '@/assets/images/partners/partner-conflux.png';
import ImageCore from '@/assets/images/partners/partner-core.png';
import ImageCube from '@/assets/images/partners/partner-cube.png';
import ImageDelight from '@/assets/images/partners/partner-delight.png';
import ImageGainsTrade from '@/assets/images/partners/partner-gains_trade.png';
import ImageJapanOpenChain from '@/assets/images/partners/partner-japan_open_chain.png';
import ImageKanalabs from '@/assets/images/partners/partner-kanalabs.png';
import ImageKddi from '@/assets/images/partners/partner-kddi.png';
import ImageKica from '@/assets/images/partners/partner-kica.png';
import ImageMch from '@/assets/images/partners/partner-mch.png';
import ImageNansen from '@/assets/images/partners/partner-nansen.png';
import ImageNeo from '@/assets/images/partners/partner-neo.png';
import ImageOasys from '@/assets/images/partners/partner-oasys.png';
import ImageOkj from '@/assets/images/partners/partner-okj.png';
import ImageOpenSea from '@/assets/images/partners/partner-open_sea.png';
import ImagePacificMeta from '@/assets/images/partners/partner-pacificmeta.png';
import ImagePlanz from '@/assets/images/partners/partner-planz.png';
import ImagePolygon from '@/assets/images/partners/partner-polygon.png';
import ImageSixNetwork from '@/assets/images/partners/partner-six_network.png';
import ImageSlash from '@/assets/images/partners/partner-slash.png';
import ImageStacks from '@/assets/images/partners/partner-stacks.png';
import ImageSynFutures from '@/assets/images/partners/partner-syn_futures.png';
import ImageTheori from '@/assets/images/partners/partner-theori.png';
import ImageThepol from '@/assets/images/partners/partner-thepol.png';

export const PARTNERS = [
  { name: 'Animoca', image: ImageAnimoca },
  { name: 'AIF', image: ImageAif },
  { name: 'Gains Trade', image: ImageGainsTrade },
  { name: 'Coinpost', image: ImageCoinpost },
  { name: 'AWS', image: ImageAws },
  { name: 'NANSEN', image: ImageNansen },
  { name: 'KDDI', image: ImageKddi },
  { name: 'Pacific Meta', image: ImagePacificMeta },
  { name: 'OKJ', image: ImageOkj },
  { name: 'Bit Trade', image: ImageBitTrade },
  { name: 'Oasys', image: ImageOasys },
  { name: 'MCH', image: ImageMch },
  { name: 'PLANZ ', image: ImagePlanz },
  { name: 'Core', image: ImageCore },
  { name: 'Japan Open Chain', image: ImageJapanOpenChain },
  { name: 'Slash', image: ImageSlash },
  { name: 'Syn Futures', image: ImageSynFutures },
  { name: 'THEPOL', image: ImageThepol },
  { name: 'Neo', image: ImageNeo },
  { name: 'Conflux', image: ImageConflux },
  { name: 'Stacks', image: ImageStacks },
  { name: 'Theori', image: ImageTheori },
  { name: 'Cube', image: ImageCube },
  { name: 'Delight', image: ImageDelight },
  { name: 'Avalanche', image: ImageAvalanche },
  { name: 'Six Network', image: ImageSixNetwork },
  { name: 'KICA', image: ImageKica },
  { name: 'Open Sea', image: ImageOpenSea },
  { name: 'Polygon', image: ImagePolygon },
  { name: 'Kanalabs', image: ImageKanalabs },
  { name: 'Coinplug', image: ImageCoinplug },
  { name: 'Chainlink', image: ImageChainlink },
];
